// 轻量登录同步（仅 H5）：slash-app <-> CreaterSlashPC
// 目标：免刷新同步 token/userInfo（同源时可用）
const CHANNEL_NAME = 'slash-auth-sync-v1';
const STORAGE_KEY = 'slash_auth_sync_v1';

let _inited = false;
let _bc = null;
let _storageHandler = null;
const _sender =
	'slash-app:' + Date.now().toString(16) + ':' + Math.random().toString(16).slice(2);

function safeJsonParse(str) {
	try {
		return JSON.parse(str);
	} catch (e) {
		return null;
	}
}

function postMessage(msg) {
	// #ifdef H5
	if (typeof window === 'undefined') return;
	try {
		window.localStorage.setItem(STORAGE_KEY, JSON.stringify(msg));
	} catch (e) {}
	try {
		if (_bc) _bc.postMessage(msg);
	} catch (e) {}
	// #endif
}

export function broadcastLogin(token, userInfoStr) {
	postMessage({
		v: 1,
		type: 'login',
		token: token || '',
		userInfo: userInfoStr || '',
		ts: Date.now(),
		sender: _sender
	});
}

export function broadcastLogout() {
	postMessage({
		v: 1,
		type: 'logout',
		ts: Date.now(),
		sender: _sender
	});
}

function applyAuthToCurrentPage() {
	// 让当前页面“立刻”感知登录变化（免刷新）
	try {
		const token = uni.getStorageSync('token');
		const userInfoStr = uni.getStorageSync('userInfo');
		const userInfoObj = typeof userInfoStr === 'string' ? safeJsonParse(userInfoStr) : userInfoStr;
		const pages = getCurrentPages();
		const cur = pages && pages.length ? pages[pages.length - 1] : null;
		const vm = cur && (cur.$vm || cur);
		if (!vm) return;

		const setVal = (k, v) => {
			try {
				vm[k] = v;
			} catch (e) {}
		};

		if (Object.prototype.hasOwnProperty.call(vm, 'isLoggedIn')) setVal('isLoggedIn', !!token);
		if (Object.prototype.hasOwnProperty.call(vm, 'userInfo')) setVal('userInfo', userInfoObj || null);
		// 常见字段：userAvatar
		if (Object.prototype.hasOwnProperty.call(vm, 'userAvatar')) {
			const slashUser = userInfoObj && (userInfoObj.slashUser || userInfoObj.user || userInfoObj);
			const avatar =
				(slashUser && slashUser.avatar) ||
				'/static/icons/searchAvatar.svg';
			setVal('userAvatar', avatar);
		}
	} catch (e) {
		// 静默
	}
}

export function initAuthSync() {
	// #ifdef H5
	if (_inited) return;
	_inited = true;
	if (typeof window === 'undefined') return;

	const handle = (e) => {
		const msg = e && e.data;
		if (!msg || msg.sender === _sender) return;
		// BroadcastChannel 需校验 origin，同源才处理
		if (e && e.origin && e.origin !== window.location.origin) return;
		if (msg.type === 'login') {
			if (msg.token) uni.setStorageSync('token', msg.token);
			if (msg.userInfo) uni.setStorageSync('userInfo', msg.userInfo);
			applyAuthToCurrentPage();
		} else if (msg.type === 'logout') {
			uni.removeStorageSync('token');
			uni.removeStorageSync('userInfo');
			applyAuthToCurrentPage();
		}
	};

	// BroadcastChannel 优先
	try {
		if ('BroadcastChannel' in window) {
			_bc = new BroadcastChannel(CHANNEL_NAME);
			_bc.onmessage = (e) => handle(e);
		}
	} catch (e) {}

	// storage 事件兜底（只在”其他标签页”触发）
	_storageHandler = (e) => {
		if (!e) return;
		// 1) 优先处理我们自己的同步消息
		if (e.key === STORAGE_KEY && e.newValue) {
			const msg = safeJsonParse(e.newValue);
			handle(msg);
			return;
		}
		// 2) 全局兜底：监听 token/userInfo 的变化（退出入口分散时也能同步）
		if (e.key === 'token' || e.key === 'userInfo') {
			applyAuthToCurrentPage();
		}
	};
	window.addEventListener('storage', _storageHandler);
	// #endif
}

export function destroyAuthSync() {
	// #ifdef H5
	if (typeof window === 'undefined') return;
	try {
		if (!_inited) return;
		_inited = false;

		if (_bc) {
			_bc.close();
			_bc = null;
		}
		// 使用 typeof 检查，避免 ReferenceError（模块提升问题）
		if (typeof _storageHandler !== 'undefined' && _storageHandler) {
			window.removeEventListener('storage', _storageHandler);
		}
		_storageHandler = null;
	} catch (e) {
		console.error('destroyAuthSync error:', e);
	}
	// #endif
}


